'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiUserDeleteOutline = function TiUserDeleteOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 23.3h-10c-0.9 0-1.7-0.7-1.7-1.6s0.8-1.7 1.7-1.7h10c0.9 0 1.7 0.7 1.7 1.7s-0.8 1.6-1.7 1.6z m-20-13.3c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z m0-3.3c-4.6 0-8.3 3.7-8.3 8.3s3.7 8.3 8.3 8.3 8.3-3.7 8.3-8.3-3.7-8.3-8.3-8.3z m0 21.6c3.4 0 5.5 1.3 6.3 2.4-1.1 0.5-3.3 1-6.3 1-3.3 0-5.3-0.5-6.4-0.9 0.8-1.2 3-2.5 6.4-2.5z m0-3.3c-6.2 0-10 3.3-10 6.7 0 1.6 3.8 3.3 10 3.3 5.9 0 10-1.7 10-3.3s-3.9-6.7-10-6.7z' })
        )
    );
};

exports.default = TiUserDeleteOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/user-delete-outline.js
// module id = 2240
// module chunks = 0